import React, { useState } from "react";

import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../services/firebaseConfig";
import { BiArrowBack } from "react-icons/bi";
import { useForm } from "react-hook-form";
// import Button from "../../../common/components/Button/Button";
import Button from "../../../common/components/Button/Button";
import BeatLoader from "react-spinners/BeatLoader";

const ForgetScreen = ({ switchLogin }) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setLoading(true);
    const actionCodeSettings = {
      url: process.env.REACT_APP_REDIRECT_URL, // Replace with your app's domain
      handleCodeInApp: true,
    };
    sendPasswordResetEmail(auth, data.username, actionCodeSettings)
      .then(() => {
        const successMessage = `Please check the email address ${data.username} for instructions to reset your password.`;
        setSuccessMessage(successMessage);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error sending password reset email:", error);
        const errorMessages = {
          "auth/user-not-found": "The email address does not exist.",
          "auth/invalid-email": "Invalid email address format.",
          "auth/network-request-failed":
            "Network request failed. Please try again.",
          "auth/too-many-requests":
            "Reset password limit exceeded. Please try again after 2 hours.",
        };

        const errorMessage =
          errorMessages[error.code] || "An unknown error occurred.";

        setErrorMessage(errorMessage);
        setSuccessMessage("");
        setLoading(false);
      });
  };

  const handleError = () => {
    setErrorMessage("");
  };

  return (
    <div className="login-sign-up--innercontainer ">
      <div className="login-forget-container">
        <p className="heading-text-forget text-start">
          <span
            className="mx-1 arrow-forgot"
            onClick={(e) => {
              e.preventDefault();
              switchLogin();
            }}
          >
            <BiArrowBack />
          </span>
          Forgot password
        </p>
        <form className="w-100" onSubmit={handleSubmit(onSubmit)}>
          <div className="sign-up-form-input-container">
            <div className="username-container">
              <label className="login-label-text" htmlFor="inputusername">
                Username<span className="requiredAstericSign">*</span>
              </label>
              <input
                className="login-input "
                id="inputusername"
                type="text"
                {...register("username", {
                  required: "Username is required",
                  validate: {
                    email: (value) =>
                      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
                        value
                      ) || "Invalid email address.",
                  },
                })}
                placeholder="Tell us your email id"
                onChange={handleError}
              />
              <span style={{ color: "red", marginTop: 20, display: "block" }}>
                {errors.username && errors.username.message}
                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}
              </span>
            </div>
            <Button type="submit" className="primary login-button mt-2">
              <BeatLoader color={"white"} loading={loading} size={10} />
              {!loading && "Send Link to email"}
            </Button>
          </div>
        </form>
        {successMessage && (
          <div>
            <p className="h3 text-center">Check Your Email</p>
            <p className="text-success text-center">{successMessage}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgetScreen;
